<template>
  <transition name="fade">
    <aside
      v-show="isActive"
      :class="{ 'sidebar--is-active': isActive }"
      class="sidebar"
      @click="handleClick"
    >
      <grid-container class="sidebar__inner">
        <div class="sidebar__content"><slot/></div>
      </grid-container>
    </aside>
  </transition>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isActive () {
      this.toggleScrollbar()
    }
  },
  mounted () {
    this.toggleScrollbar()
  },
  methods: {
    toggleScrollbar () {
      document.documentElement.style.overflow = this.isActive ? 'hidden' : ''
    },
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="scss" scoped>
  .sidebar {
    @include hide-up(md);
    @include theme(background-color);

    padding-top: 136px;
    overflow-y: hidden;

    position: fixed;
    top: 0;
    left: 0;
    z-index: z(navbar) - 1;

    width: 100%;
    height: 100%;
    overflow: auto;

    &__inner {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      max-height: 100%;
    }

    &__content {
      padding-bottom: 36px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Navigation/Sidebar.vue